import styled from "styled-components";
import { Theme } from "theme";
type RankSelectFontSize = "normal" | "small" | "smaller";

const handleRankSelectFontSize = (
  size: RankSelectFontSize,
  normalSize: number
) => {
  switch (size) {
    case "normal":
      return `font-size: ${normalSize * 1}pt;`;
    case "small":
      return `font-size: ${normalSize * 0.8}pt;`;
    case "smaller":
      return `font-size: ${normalSize * 0.6}pt;`;
  }
};

export const GroupOrgLogoContainer = styled.div<{ frozen: boolean }>`
  height: 42px;
  width: 42px;

  ${({ frozen }) => frozen && `opacity: 0.6;`}
  @media (max-width: 700px) {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 450px) {
    width: 28px;
    height: 28px;
  }
`;

export const GroupDisplayName = styled.div<{ frozen: boolean }>`
  width: 190px;
  font-size: 13pt;
  margin-left: 6px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;

  ${({ frozen }) => frozen && `color: darkgray;`}

  @media (max-width: 700px) {
    font-size: 12pt;
    width: 166px;
  }

  @media (max-width: 450px) {
    display: none;
  }
`;

export const MobileGroupDisplayName = styled.div<{ frozen: boolean }>`
  font-size: 11pt;
  width: 75px;
  margin-left: 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;

  ${({ frozen }) => frozen && `color: darkgray;`}

  @media (min-width: 450px) {
    display: none;
  }
`;

export const RankSelectBox = styled.div<{
  selected: boolean;
  otherSelected: boolean;
  availableToSelect: boolean;
  frozen: boolean;
  fontSize: RankSelectFontSize;
}>`
  width: 65px;
  height: 65px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${({ fontSize }) => handleRankSelectFontSize(fontSize, 16)};
  font-weight: bold;
  background: gainsboro;
  color: darkgray;
  border: 1px solid transparent;
  user-select: none;
  white-space: nowrap;
  ${({ selected }) =>
    selected &&
    `background: ${Theme.navActiveBackground}; color: ${Theme.buttonHoverForeground}; border-color: ${Theme.buttonHoverForeground};`}

  ${({ availableToSelect }) =>
    !availableToSelect && `color: gainsboro; cursor: default;`}

  ${({ otherSelected }) => otherSelected && `color: gainsboro;`}
      
    &:hover {
    ${({ selected, frozen, availableToSelect }) =>
      availableToSelect &&
      !selected &&
      !frozen &&
      `background: ${Theme.buttonHoverBackground}; color: ${Theme.buttonHoverForeground};`}
  }

  ${({ frozen }) => frozen && `cursor: default;`}
  ${({ frozen, selected }) =>
    frozen &&
    selected &&
    `color: gray; background: darkgray; border-color: gray;`}

  @media (max-width: 700px) {
    width: 50px;
    height: 50px;
    ${({ fontSize }) => handleRankSelectFontSize(fontSize, 12)};
  }

  @media (max-width: 450px) {
    width: 40px;
    height: 40px;
    ${({ fontSize }) => handleRankSelectFontSize(fontSize, 11)};
  }
`;
